// Imports
// ------
import React from 'react';
import { graphql } from 'gatsby';
import Footer from '@components/global/footer/footer';
import Hero from '@global/hero/hero';
import Content from '@components/legal/content/content';
import { Animation } from '@reuse';
import Helmet from 'react-helmet';
import Popup from '@global/popup/popup';

// Component
// ------
export default class GdprPage extends React.PureComponent {
    render() {
        const metaTitle = `Terms | Mortgages Remortgages`;
        const metaDesc = this.props.data.site.siteMetadata.description;

        return (
            <>
                <Helmet>
                    {/* Global */}
                    <title>{metaTitle}</title>
                    <meta name="description" content={metaDesc}/>
                </Helmet>

                <Animation transitionStatus={this.props.transitionStatus}>
                    <Hero
                        title={this.props.data.datoCmsTerm.title}
                    />
                    
                    <Content
                        content={this.props.data.datoCmsTerm.content}
                    />

                    <Footer
                        facebook={this.props.data.datoCmsContactInformation.facebook}
                        twitter={this.props.data.datoCmsContactInformation.twitter}
                        linkedin={this.props.data.datoCmsContactInformation.linkedin}
                        privacyPolicy={this.props.data.datoCmsLegalDocument.privacyPolicyGdpr.url}
                        reviewsLink={this.props.data.datoCmsContactInformation.reviewsLink}
                    />
                </Animation>

                <Popup />
            </>
        )
    }
}

// GraphQL
// ------
export const query = graphql`
    query termsPageQuery {
        datoCmsTerm {
            title
            content
        }

        site {
            siteMetadata {
                title
                description
            }
        }

        datoCmsContactInformation {
            phoneNumber
            facebook
            twitter
            linkedin
            reviewsLink
        }

        datoCmsLegalDocument {
            privacyPolicyGdpr {
                url
            }
        }
    }
`;